export default __webpack_public_path__ + "static/media/er7.4790d583.jpg";